export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export type AlertData = {
  title: string;
  severity?: 'error' | 'success' | 'warning' | 'info';
  onClose?: () => void;
};

export const showAlert = (payload: AlertData) => ({
  type: SHOW_ALERT,
  payload,
});

export const hideAlert = () => ({
  type: HIDE_ALERT,
  payload: null,
});
